import React from 'react'

import { useTranslation } from 'react-i18next'
import { Navigate } from 'react-router-dom'
import styled from 'styled-components'

import { Spinner, Text } from '@fairhq/common'

import { Layout } from 'layout/Layout'

import { useGetSurveyWindowArchiveComparisonQuery } from 'store/surveyWindow/surveyWindowApi'

import { BiggestGains } from './BiggestGains'
import { CategoriesOverview } from './CategoriesOverview'
import { FairExperience } from './FairExperience'
import { useHadFullSurvey } from './hooks/useHadFullSurvey'

const Header = styled.header`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
`

export const ReportsExperience = () => {
  const { t } = useTranslation()

  const { data, isFetching, isSuccess } =
    useGetSurveyWindowArchiveComparisonQuery()
  const latestSurveyWindow = data?.[0]
  const previousSurveyWindow = data?.[1]

  const { hadFullSurvey } = useHadFullSurvey(data)

  if (isSuccess && !hadFullSurvey) {
    return <Navigate to="/404" />
  }

  return (
    <Layout
      contentSx={{ display: 'flex', flexDirection: 'column', gap: '60px' }}
      dark
    >
      <Header>
        <Text element="h1" type="heading" size="xl" fontWeight={700}>
          {t(`experience.title`)}
        </Text>
      </Header>
      {isFetching && <Spinner center />}
      {isSuccess && latestSurveyWindow && (
        <>
          <CategoriesOverview
            latestSurveyWindowId={latestSurveyWindow.id}
            previousSurveyWindowId={previousSurveyWindow?.id}
          />

          <FairExperience latestSurveyWindowId={latestSurveyWindow.id} />

          {previousSurveyWindow && (
            <BiggestGains latestSurveyWindowId={latestSurveyWindow.id} />
          )}
        </>
      )}
    </Layout>
  )
}
